import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute bottom-10 left-10 z-10 max-w-[480px] p-6 flex items-center gap-8 bg-white"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/svg/qrcode.svg",
  width: "150",
  height: "150",
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_timeline = _resolveComponent("timeline")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showQrCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_ui_icon, {
            name: "arrow-left",
            class: "text-6xl text-tertiary"
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('scan_qrcode')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_timeline, { "is-presentation-mode": true })
  ]))
}